import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const handleEditShow = (isEditVisible, handleEdit) => {
  if (isEditVisible) {
    return (
      <p>
        <a
          id='virtualVoucher-btn-editEmail'
          href='javascript:void(0)'
          className='txt-body-sm txt-font-body color-brand-1'
          onClick={handleEdit}
          role='button'
        >
          Alterar
        </a>
      </p>
    )
  }

  return ''
}

const Viewer = ({ email, isEditVisible, handleEdit }) => {
  return (
    <Fragment>
      <div className='col-3 txt-title-3 txt-body-sm txt-font-body color-ui-2 txt-left justify-content-center align-self-center'>
        E-mail:
      </div>
      <div className='col-9 txt-title-3 txt-body-sm txt-subtitle txt-font-body color-ui-2 txt-right justify-content-center align-selfe-center'>
        <p
          id='virtualVoucher-viewer-email'
          className='txt-body-sm txt-font-body color-ui-2'
        >
          {email}
        </p>
        {handleEditShow(isEditVisible, handleEdit)}
      </div>
    </Fragment>
  )
}

Viewer.propTypes = {
  email: PropTypes.string.isRequired,
  isEditVisible: PropTypes.bool.isRequired,
  handleEdit: PropTypes.func.isRequired
}

export default Viewer



// WEBPACK FOOTER //
// ./src/features/Cart/Summary/VirtualVoucher/Viewer/Viewer.js